import { render, staticRenderFns } from "./ColumnElement.vue?vue&type=template&id=39695059&scoped=true&"
import script from "./ColumnElement.vue?vue&type=script&lang=js&"
export * from "./ColumnElement.vue?vue&type=script&lang=js&"
import style0 from "./ColumnElement.vue?vue&type=style&index=0&id=39695059&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39695059",
  null
  
)

export default component.exports